// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__35Rqk","label":"Labeled_label__1Q4NC","divider":"Labeled_divider__jmJjQ"};